import React, { Component } from "react";
import {
  Container,
  Button,
  ModalFooter,
  ModalBody,
  Card,
  Row,
  
} from "reactstrap";


let sounds = [{key:'bell',select:false},{key:'callring',select:true}]
// sounds = {bell : false, callring: true}
export default class SelectSound extends Component {
  constructor(props) {
    super(props);
    this.state = {sounds:sounds};
  }
  componentWillMount(){
    this.defaultSelectedSound()
  }
  defaultSelectedSound(){
    let checkSound = localStorage.getItem('sound');
    let sounds = this.state.sounds;
    if(checkSound !== null)
    {
        for(let i=0;i< sounds.length ; i++ ){
            if(sounds[i].key === checkSound)
            { 
                sounds.select = true

            }else{
                
                sounds.select = false
            }
        }
        
    }else{
        localStorage.setItem("sound", 'bell')
    }
    this.setState({sounds:sounds})
  }

  selectedSound(){
    let sound= '';
    let sounds = this.state.sounds;
    for(let i=0;i< sounds.length ; i++ ){
       
        if(sounds[i].select === true){
            sound = sounds[i].key;
        }
    }
    console.log('sound--'+sound)
   if(sound === ''){
    this.props.goBack();
   }else{
       localStorage.setItem("sound",sound)
       this.props.goBack();
   }

  }
  handleClick =(index)=>{
    // let snd = this.state.sounds;
    console.log('sounds'+this.state.sounds.length );
    let sounds = this.state.sounds;
    for(let i=0;i< sounds.length ; i++ ){
        console.log(index)
        if(i === index)
        {
            console.log(i)
            if(sounds[i].select){
               
                sounds[i].select =false
            }else{
                
                sounds[i].select =true
            }
        }else{
            console.log('fal',sounds[i].select)
            
            sounds[i].select = false
        }
    }
    this.setState({sounds:sounds})
  }
  render() {
    return (
      <Container fluid style={{ padding: 0, margin: 0, alignItems: "center" }}>
        <ModalBody>
            <h5 style={{ margin: 10 }}> Select Sound to ring in new order status</h5>
            {this.state.sounds.map((sound, index) => {
                return (
                    <Row >
                    <Card
                    onClick={()=> {
                        this.handleClick(index)
                    }}
                    className={sound.select === true ? 'p-0 bg-success' : 'white'}
                    style={{
                        display: "flex",
                        margin: 10,
                        color: "black"
                    }}
                    >
                    <audio id = 'audio'
                        style={{margin:15}}
                        controls
                        src={ require("../../assets/sounds/"+sound.key+".mp3")}></audio> 
                    </Card>
                    </Row>
                
            )})}
        </ModalBody>
        <ModalFooter>
            <div>
                <Button
                color="success"
                onClick={() => {
                    this.selectedSound()
                }}
                >
                Confirm
                </Button>{" "}
                <Button
                color="danger"
                style={{paddingLeft:32,paddingRight:32}}
                onClick={() => {
                    this.props.goBack();
                }}
                >
                No
                </Button>
            </div>
        </ModalFooter>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SoundCard/SelectSound.js